<header>
  <div class="header pe-5 d-flex flex-row justify-content-between align-items-center position-relative">
    <div
      class="header-logo position-relative d-flex flex-nowrap align-items-center justify-content-start px-6 overflow-hidden gap-0"
    >
      <div class="d-flex flex-no-wrap align-items-center flex-shrink-0">
        <i
          *ngIf="!isMagicTokenLoginPage && !isError401"
          class="d-xl-none pointer icon-lg fa-solid fa-fw fa-bars me-3"
          (click)="openOffcanvasSidebar(appSectionsSidebar)"
        ></i>
        <picture [ngClass]="isMagicTokenLoginPage || isError401 ? 'no-pointer' : 'pointer'">
          <source
            media="(max-width: 576px)"
            [srcset]="logoSmall"
          />
          <img
            class="img-fluid pointer"
            [src]="logo"
            alt="Logo"
            [routerLink]="stazzleLogoUrl"
            [replaceUrl]="true"
          />
        </picture>
      </div>
      <div class="header-dot mx-3 mx-md-4 mt-1"></div>
      <div class="header-title mt-1 overflow-hidden">
        <base-page-title></base-page-title>
      </div>
    </div>

    <div class="header-right d-flex justify-content-between align-items-center mt-0">
      <div class="header-user-nav d-flex justify-content-between align-items-center">
        <ng-container *ngIf="isFullscreen">
          <base-button
            baseBackButton
            [size]="buttonSizes.lg"
            [iconSize]="buttonSizes.lg"
            color="dark"
            icon="fa-solid fa-close"
          ></base-button>
        </ng-container>
        <ng-container *ngIf="!isFullscreen && !isErrorPage && !isMagicTokenLoginPage && !isResetPasswordPage">
          <base-user-nav
            [userMenu]="userMenu"
            (openUserMenuSidebar)="openOffcanvasSidebar(userMenuSidebar, true)"
          ></base-user-nav>
        </ng-container>
        <ng-container *ngIf="!isFullscreen && (isErrorPage || isResetPasswordPage)">
          <base-error-page-header-nav [is401]="isError401"></base-error-page-header-nav>
        </ng-container>
      </div>
    </div>
  </div>
</header>

<ng-template #appSectionsSidebar>
  <div class="offcanvas-body">
    <base-application-sections-sidebar
      [sections]="applicationSections"
      [areSectionsVisible]="!isErrorPage"
    ></base-application-sections-sidebar>
  </div>
</ng-template>

<ng-template #userMenuSidebar>
  <div class="offcanvas-body">
    <base-base-user-menu-sidebar [userMenu]="userMenu"></base-base-user-menu-sidebar>
  </div>
</ng-template>
